import { Box, Typography } from "@mui/material";
import ReactMarkdown from "react-markdown";

const WriteUpComponent = ({ gameSummary }: { gameSummary: string }) => {
  return (
    <Box
      sx={{
        bgcolor: "lightgray",
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <Box
        sx={{
          px: 2,
          py: 1,
          flexGrow: 1,
          "& > *": {
            fontStyle: "normal",
            textTransform: "none",
            fontWeight: 400,
            fontSize: 16,
            textAlign: "start",
          },
        }}
      >
        <Typography
          variant="h5"
          sx={{
            fontWeight: 500,
            textAlign: "center",
            pb: 2,
            fontSize: 24,
            color: "black",
          }}
        >
          Game Summary
        </Typography>
        <ReactMarkdown>{gameSummary}</ReactMarkdown>
      </Box>
    </Box>
  );
};

export default WriteUpComponent;
